import { SxProps, Theme } from "@mui/material"

export const COLUMN_WIDTH = {
  numericOrder: 45,
  isSelected: 60,
  label: 300,
  type: 115,
  link: 350,
  unitShowAsPercentage: 75,
  unitDecimalPlaces: 105,
  unitSuffix: 150,
  historicMnemonic: 350,
  scenarioMnemonic: 350,
  forecastMnemonic: 350,
  tags: 300,
  graphTags: 300,
} as const

// left offsets are the cumulative widths of the sticky columns (No., checkbox, Label) preceding each one
export const STICKY_COLUMN_LEFT = {
  numericOrder: 0,
  isSelected: COLUMN_WIDTH.numericOrder,
  label: COLUMN_WIDTH.numericOrder + COLUMN_WIDTH.isSelected,
} as const

export const getStickyColumnSx = (
  left: number,
  options?: { isHeader?: boolean },
): SxProps<Theme> => ({
  position: "sticky",
  left,
  // header sticky cells must stay above both regular sticky header cells and sticky body cells
  zIndex: options?.isHeader ? 3 : 1,
  ...(options?.isHeader ? {} : { backgroundColor: "background.paper" }),
})
